import React, { useCallback, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'

// pages
import Home from './Home'
// import Services from './Services'
import Blogs from './Blogs'
import Employee from './Employee'
import Messages from './Messages'
import Settings from './Settings'
import WebsiteSettings from './WebsiteSettings'
import Users from "./Users"
import PrivateRoute from 'components/PrivateRoute'
import Applications from './Applications'
import Courses from './Courses'
import Students from './Students'
import { useDataContext } from 'contexts/Data'
import axios from 'axios'

export default function Index() {

    const { setState } = useDataContext()

    const readDocuments = useCallback(data => {
        const { token } = data
        const config = { headers: { Authorization: `Bearer ${token}` } }
        axios.get(`${window.api}/courses/global-courses`, config)
            .then((res) => {
                let { data, status } = res
                if (status === 200) {
                    setState(s => ({ ...s, courses: data.courses }))
                }
            }).catch((err) => {
                console.error(err)
                window.toastify(err.response?.data?.message || "Something went wrong while getting the courses", "error")
            })
    }, [])

    useEffect(() => {
        let token = localStorage.getItem("jwt")
        if (token) { readDocuments({ token }) }
    }, [readDocuments])


    return (
        <div className="dashboard">
            <Routes>
                <Route path='/' element={<Home />} />
                {/* <Route path='services/*' element={<Services />} /> */}
                <Route path='applications/*' element={<Applications />} />
                <Route path='courses/*' element={<Courses />} />
                <Route path='blogs/*' element={<Blogs />} />
                <Route path='employee/*' element={<Employee />} />
                <Route path='students/*' element={<Students />} />
                <Route path='messages/*' element={<PrivateRoute Component={Messages} allowedRoles={['superAdmin']} />} />
                <Route path='settings/*' element={<Settings />} />
                <Route path='website-settings/*' element={<PrivateRoute Component={WebsiteSettings} allowedRoles={['superAdmin']} />} />
                <Route path='admin/*' element={<PrivateRoute Component={Users} allowedRoles={['superAdmin']} />} />
            </Routes>
        </div>
    )
}
